module.exports = __webpack_public_path__ + "img/code1.aa0c6a85.png";